import { Rpc } from '@lightprotocol/stateless.js';
import {
  ASSOCIATED_TOKEN_PROGRAM_ID,
  getAssociatedTokenAddress,
  TOKEN_PROGRAM_ID,
} from '@solana/spl-token';
import { PublicKey } from '@solana/web3.js';

/**
 * Retrieves the decompressed balance from the associated token account.
 * If fetching fails, it returns 0.
 *
 * @param publicKey - The owner's public key.
 * @param mintAddress - The mint address of the token.
 * @param connection - The RPC connection instance.
 * @returns The decompressed balance as a number.
 */
export const getDecompressedBalance = async (
  publicKey: PublicKey,
  mintAddress: PublicKey,
  connection: Rpc,
): Promise<number> => {
  const ata = await getAssociatedTokenAddress(
    mintAddress,
    publicKey,
    false,
    TOKEN_PROGRAM_ID,
    ASSOCIATED_TOKEN_PROGRAM_ID,
  );
  try {
    const account = await connection.getTokenAccountBalance(ata);
    return Number(account.value.amount);
  } catch (err) {
    return 0;
  }
};
